/**
 * 平台专区筛选项列表
 * @author tanglinxia
 * @since 22/04/14
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from '@fe/common/lib/debounce';
import clone from '@fe/common/lib/clone';
import cx from 'classnames';
import './store-filters-openzone.less';

// 系统筛选项-推荐[全部]类型为4
// const RECOMMEND_ID = 4;
// 小屏适配最大屏幕宽度
const SMALL_WINDOW_MAX_WIDTH = 1366;
// 小屏子筛选框宽度
const SMALL_SUB_BOX_WIDTH = 730;
// 大屏子筛选框宽度
const LARGE_SUB_BOX_WIDTH = 950;
// 子筛选项font-size
const SUB_FONT_SIZE = 14;
// 子筛选项margin-right
const SUB_MARGIN_RIGHT = 34;
// 全部-fieldKey
const ALL_KEY = 'ALL';
// 最大显示行数
const MAX_FILTER_ROW = 8;

export default class StoreFiltersOpenZone extends Component {
  static propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    selectedFilters: PropTypes.object,
  };
  constructor() {
    super();
    this.state = {
      subBoxWidth: 0,
      foldingTagIds: [],
      isShowMore: false,
    };
  }

  componentDidMount() {
    // 调整屏幕大小时，`更多`按钮进行适配
    window.addEventListener('resize', debounce(this.getSubBoxWidth, 300));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', debounce(this.getSubBoxWidth, 300));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters !== this.props.filters) {
      // 初始化子筛选项容器宽度
      const subBoxWidth = this.getSubBoxWidth();
      this.setState({ subBoxWidth });
    }
  }

  // 根据屏幕宽度计算子筛选项容器宽度
  getSubBoxWidth() {
    return window.innerWidth >= SMALL_WINDOW_MAX_WIDTH
      ? LARGE_SUB_BOX_WIDTH
      : SMALL_SUB_BOX_WIDTH;
  }

  // 检查是否需要折叠
  checkFoldable(list = []) {
    const { subBoxWidth } = this.state;
    const nameStr = list.map(item => item.name).join('');
    const nameWidth =
      nameStr.length * SUB_FONT_SIZE + SUB_MARGIN_RIGHT * (list.length - 1);
    return nameWidth > subBoxWidth;
  }

  // 根据id获取tag
  findFilterById(id) {
    const { systemTags } = this.props.filters;
    return systemTags && systemTags.filter(item => item.firstId === id)[0];
  }

  // 获取被选中的系统标签
  findSelectedThirdKey(secondKey) {
    const { systemTags } = this.props.selectedFilters;
    const index = systemTags.findIndex(tag => tag.secondFieldKey === secondKey);
    const thirdKey = index === -1 ? ALL_KEY : systemTags[index].thirdFieldKey;
    return [index, thirdKey];
  }

  // sub-filter折叠处理
  handleFolderList(id) {
    const { foldingTagIds } = this.state;
    const index = foldingTagIds.findIndex(foldingId => foldingId === id);
    index === -1 ? foldingTagIds.push(id) : foldingTagIds.splice(index, 1);
    this.setState({ foldingTagIds });
  }

  // 切换一级系统筛选项
  changeFirstTag(filter) {
    const { setFilters } = this.props;
    this.setState({
      foldingTagIds: [],
      isShowMore: false,
    });
    setFilters({ firstId: filter.firstId, systemTags: [] });
  }

  // 选择系统筛选项
  handleSelect(thirdKey, secondFilter) {
    const { selectedFilters, setFilters } = this.props;
    const { fieldKey: secondKey } = secondFilter;
    let newTags = clone(selectedFilters.systemTags, true);
    // 判断被选中的系统筛选项是否包含该分类
    const [index, selectedThirdKey] = this.findSelectedThirdKey(secondKey);
    // 已存在该二级字段
    if (index !== -1) {
      if (thirdKey === selectedThirdKey) return;
      // 若选中ALL则清除对应筛选项，否则更新thirdFieldKey
      thirdKey !== ALL_KEY
        ? (newTags[index].thirdFieldKey = thirdKey)
        : newTags.splice(index, 1);
    } else {
      // 不存在，且不为ALL，则push
      if (thirdKey === ALL_KEY) return;
      newTags.push({
        secondFieldKey: secondKey,
        thirdFieldKey: thirdKey,
      });
    }

    setFilters({ systemTags: [...newTags] });
  }

  // 选择自定义标签筛选项
  handleSelectCustomTag = (tagId, tags) => {
    const { selectedFilters, setFilters } = this.props;

    const { customTagIds } = selectedFilters;
    let newIds = clone(customTagIds, true);
    const index = customTagIds.findIndex(id => id === tagId);
    // 点全部清除筛选项
    if (tagId === 'ALL') {
      const clearIds = tags.map(tag => tag.tagId);
      newIds = customTagIds.filter(id => !clearIds.includes(id));
    } else {
      // 切换选中状态
      index === -1 ? newIds.push(tagId) : newIds.splice(index, 1);
    }
    setFilters({ customTagIds: newIds });
  };

  // 检查自定义标签是否被全选
  checkHasSelectedTag(tags = []) {
    const { customTagIds } = this.props.selectedFilters;
    return tags.some(tag => customTagIds.includes(tag.tagId));
  }

  // 渲染一级系统筛选项
  renderfirstSTags(tags) {
    const { selectedFilters } = this.props;
    return (
      <div className="filter-row">
        <span className="filter-title">作品类型</span>
        <div className="sub-filter-list">
          {tags.length > 0 &&
            tags.map(filter => {
              const { firstId, name } = filter;
              return (
                <span
                  className={cx('sub-filter', {
                    active: firstId === selectedFilters.firstId,
                  })}
                  onClick={() => {
                    this.changeFirstTag(filter);
                  }}
                  key={firstId + name}>
                  {name}
                </span>
              );
            })}
        </div>
      </div>
    );
  }

  // 渲染二级系统筛选项
  renderCurrentSTags(tags) {
    const { foldingTagIds } = this.state;
    return tags.map(item => {
      const { name, children, fieldKey } = item;
      const foldable = children && this.checkFoldable(children);
      // 获取当前二级分类被选中的thirdKey
      const selectThirdKey = this.findSelectedThirdKey(fieldKey)[1];
      const folding = !!foldingTagIds.find(id => id === fieldKey);
      return (
        <li
          key={fieldKey + name}
          className={cx('filter-row', {
            foldable: foldable,
            folding,
          })}>
          <span className="filter-title">{name}</span>
          <ul className="sub-filter-list">
            {this.renderSubFilters(children, selectThirdKey, item)}
          </ul>
          <span
            className="fold-btn"
            onClick={() => this.handleFolderList(fieldKey)}>
            <span className="fold-text">{folding ? '收起' : '更多'}</span>
            <span className="down-arrow" />
          </span>
        </li>
      );
    });
  }

  // 渲染三级筛选项
  renderSubFilters(tags, selectThirdKey, secondFilter) {
    return tags.map(item => {
      const { name, id, fieldKey } = item;
      return (
        <li
          className={cx('sub-filter', {
            active:
              fieldKey === selectThirdKey ||
              (!selectThirdKey && fieldKey === ALL_KEY),
          })}
          onClick={() => this.handleSelect(fieldKey, secondFilter)}
          key={id + name}>
          {name}
        </li>
      );
    });
  }

  // 渲染自定义sub标签
  renderCustomSub(tags) {
    const { customTagIds } = this.props.selectedFilters;
    const hasSelected = tags && this.checkHasSelectedTag(tags);
    return tags.map(item => {
      const { name, tagId } = item;
      return (
        <li
          className={cx('sub-filter', {
            active:
              customTagIds.includes(tagId) ||
              (!hasSelected && tagId === ALL_KEY),
          })}
          onClick={() => this.handleSelectCustomTag(tagId, tags)}
          key={tagId + name}>
          {name}
        </li>
      );
    });
  }

  // 渲染自定义标签
  renderCustomTags(customTags) {
    const { foldingTagIds } = this.state;
    return customTags.map(item => {
      const { groupName, tags, groupId } = item;
      if (!tags || (Array.isArray(tags) && tags.length < 1)) return '';
      const foldable = tags && this.checkFoldable(tags);
      // 获取当前二级分类被选中的thirdKey
      const folding = !!foldingTagIds.find(id => id === groupId);
      return (
        <li
          key={groupId + groupName}
          className={cx('filter-row', {
            foldable: foldable,
            folding,
          })}>
          <span className="filter-title">{groupName}</span>
          <ul className="sub-filter-list">
            {tags && this.renderCustomSub(tags)}
          </ul>
          <span
            className="fold-btn"
            onClick={() => this.handleFolderList(groupId)}>
            <span className="fold-text">{folding ? '收起' : '更多'}</span>
            <span className="down-arrow" />
          </span>
        </li>
      );
    });
  }

  render() {
    const { filters, selectedFilters } = this.props;
    const { isShowMore } = this.state;
    const { systemTags, customTags } = filters;
    // 获取当前系统标签
    const currentSystemTag = this.findFilterById(selectedFilters.firstId) || [];
    // 计算是否展示查看更多按钮
    const systemRows =
      systemTags &&
      currentSystemTag &&
      currentSystemTag.children &&
      currentSystemTag.children.length + 1;
    const customRows = customTags && customTags.length;
    const hasMore = customRows + systemRows > MAX_FILTER_ROW;
    return (
      <div
        className={cx('store-filters-openzone', {
          folding: isShowMore,
          hasMore,
        })}>
        <ul className="filter-list">
          {systemTags && this.renderfirstSTags(systemTags)}
          {currentSystemTag &&
            currentSystemTag.children &&
            this.renderCurrentSTags(currentSystemTag.children)}
          {customTags && this.renderCustomTags(customTags)}
        </ul>
        <div
          className="fold-btn more-btn"
          onClick={() => this.setState({ isShowMore: !isShowMore })}>
          <span className="fold-text">{isShowMore ? '收起' : '查看全部'}</span>
          <span className="down-arrow" />
        </div>
      </div>
    );
  }
}
